module.exports = __webpack_public_path__ + "arr_up.adce8a52.png";